import { render, staticRenderFns } from "./UpdateVisaDataComponent.vue?vue&type=template&id=446ce704&"
import script from "./UpdateVisaDataComponent.vue?vue&type=script&lang=js&"
export * from "./UpdateVisaDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports